import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";


@Injectable({
  providedIn: 'root'
})
export class InvestmentCostingService {


  investment_cost = '/assets/mockdata/Investment_Costing.json';
  rld_cost = '/assets/mockdata/rld_cost.json';
  newCosting = '/assets/mockdata/NewCosting.json';
  timelineCosting = '/assets/mockdata/timeline.json'

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }


  getInvestmentCostDetails() {
    return this.http.get(this.investment_cost);
  }

  displayAPICost(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.POSTAPICOST.POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  editAPICost(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.POSTAPICOST.EDIT_APICOST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  getRegulatoryCost(data): Observable<any[]> {
    return this.http.post<any[]>(`${AppConstants.API_ENDPOINT}${AppConstants.API.REGULATORYCOST.GET}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  displayBEStudy(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.BESTUDYCOST.POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  rldStudyCost(data) {
    // return this.http.get(this.rld_cost);
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.RLDSTUDYCOST.POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }


  getAnalyticalCost(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.ANALITICALCOST.POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }


  getIpCost(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.IPCOST.POST}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  //TIMELINE-INVESTMENT_COSTING
  // getTimeline(data){
  //   return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.TIMELINE.POST}`, data);
  // }


  /**
   * 
   * @returns New costing details 
   */
  getNewCosting() {
    return this.http.get(this.newCosting);
  }


  // /**
  //  * 
  //  * @returns New costing details 
  //  */
  //  getTimeline(){
  //   return this.http.get(this.timelineCosting);
  // }

  getTimeline(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.Timelines.POST}`, data);
  }

  getCumulativeInvestment(data) {
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.CUMULATIVE_INVESTMENT.POST}`, data);
  }
}
